// schema
import * as ISchema from "@schema";

import { commitMutation } from "react-relay";
import { removeUserTagsMutation } from "@src/mutations/RemoveUserTags.gql";
import { modernCache } from "@network/modern-network-layer";

// TYPES
interface IRemoveUserTagsMutationResponse {
  removeOrgTags: ISchema.IRemoveOrgTagsMutationPayload;
}

// MUTATION
// NOTE: this is actually identical to removeOrgTags except the mutation fragments ask for userTags back
export function removeUserTags(
  environment: any,
  orgRelayId: string,
  eventParentRelayId: string,
  tagNames: string[],
  onSuccess: (response?: ISchema.IRemoveOrgTagsMutationPayload) => void,
  onError: (error?: any) => void,
) {
  const variables = {
    input: {
      orgRelayId,
      eventParentRelayId,
      tagNames,
    },
  };

  commitMutation(environment, {
    variables,
    onError,
    mutation: removeUserTagsMutation,
    onCompleted: (response: IRemoveUserTagsMutationResponse, errors?: Error[]) => {
      if (!!errors) {
        onError(errors[0]);
      } else {
        // if we're not in a modern environment, modernCache will be undefined
        if (modernCache) {
          modernCache.clear();
        }
        onSuccess(response.removeOrgTags);
      }
    },
  });
}
